import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";

interface QueryErrorProps {
  className?: string;
}

export function QueryError({ className }: QueryErrorProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center gap-2 p-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm ${className ?? ""}`}
      role="alert"
    >
      <AlertCircle size={16} className="shrink-0" />
      <span>{t("common.error", "Ocurrió un error. Por favor, intente de nuevo.")}</span>
    </div>
  );
}
